(function ($) {
    function tabBase() {
        var container = $('.tabbed-forms');
        var tabs = container.find('.tabs').find('a');
        var forms = container.find('.forms').find('> div');

        tabs.removeClass('active');
        forms.hide();
        $('a[data-tab-id=short]').addClass('active');
        $('#short').show();
    }

    function switchTabs(e) {
        e.preventDefault();

        var clickedTab = $(this);
        var clickedPanelId = clickedTab.data('tab-id');
        var clickedPanel = $('#' + clickedPanelId);
        var container = clickedTab.closest('.tabbed-forms');
        var tabs = clickedTab.parent().find('a');
        var forms = container.find('.forms').find('> div');

        tabs.removeClass('active');
        clickedTab.addClass('active');
        forms.hide();
        clickedPanel.show();
        window.location.hash = '#' + clickedPanelId;
    }

    function prepTabs() {
        var container = $('.tabbed-forms');
        var tabsContainer = container.find('.tabs');
        var tabs = tabsContainer.find('a');
        var pageHash = window.location.hash;

        tabs.on('click', switchTabs);

        switch (pageHash) {
            case '#long':
                $('a[data-tab-id=long]').click();
                break;
            case '#short':
                tabs.first().click();
                break;
            default:
                tabBase();
        }
    }

    $(document).ready(prepTabs);
})(jQuery);